import React, { useEffect, useState } from "react";
import { Navigate, Outlet  } from "react-router-dom";
import { logoutUser } from "./Helpers/logoutHelper";
import MiniDrawer from "./components/Menubar/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { fetchPdfEditorDetails } from "./store/reducers/pdfEditorTokenSlice";
import { checkActiveLogin } from "./store/reducers/activeLoginSlice";

const ProtectedLayout = ({ token }) => {
  const [open, setOpen] = useState(true);
  const [openSideBar, setOpenSideBar] = useState(true);
  const dispatch = useDispatch();
  const { profileData } = useSelector((state) => state.profile);

  const { is_active, status } = useSelector((state) => state.activeLogin);

  useEffect(() => {
    if (token && status === "idle") {
      dispatch(checkActiveLogin());
    }
  }, [dispatch, token, status]);

  useEffect(() => {
    if (token && status === "succeeded") {
      if (!is_active) {
        logoutUser();
      } else {
        sessionStorage.setItem("token", "success");
      } 
    }
  }, [token, is_active, status]);


  useEffect(() => {
    if (profileData?.status === true && profileData.username && token) {
      dispatch(fetchPdfEditorDetails(profileData.username));
    }
  }, [profileData.status, profileData.username, token, dispatch]);
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  return (
    <>
      <MiniDrawer open={open} setOpen={setOpen} setOpenSideBar={setOpenSideBar} openSideBar={openSideBar} />

      <Outlet context={{ open, setOpen, openSideBar, setOpenSideBar }} />
    </>
  );
};

export default ProtectedLayout;
